import { render, staticRenderFns } from "./b-initial.vue?vue&type=template&id=4085ff5c&"
import script from "./b-initial.vue?vue&type=script&lang=js&"
export * from "./b-initial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports